import React, {Component, Fragment} from 'react'
import DataTableForm from "../Components/Forms";
import {_getShow, _patch, _post} from "../Api";
import {
    Form,
    Button,
    UncontrolledAlert
} from "reactstrap";

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {
    faWindowClose,
    faCloudUploadAlt
} from '@fortawesome/free-solid-svg-icons'

class Edit extends Component {

    constructor(props) {
        super(props);
        this.state = {
            errorMessage: {},
            successMessage: false
        };

        this.handleUploadImages = this.handleUploadImages.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    queryAPI() {
        let itemId;
        if (this.props.item) {
            itemId = this.props.item
        } else {
            itemId = this.props.id
        }
        _getShow(this.props.db, itemId).then(res => {
            this.setState({formEdit: res.data.show, fields: res.data.fields})
        })
    }

    componentDidMount() {
        this.queryAPI();

    }

    handleUploadPut() {
        (this.state.selectedFiles) && this.state.selectedFiles.map(async (file) => {
            let formData = new FormData();
            formData.append('files', file)
            await _post(this.props.db + "/" + this.props.item + "/" + file.fieldName, formData)
        })
        this.props.notificationComponent({type: "success", message: ["Data edited successfully"]})
        this.props.hideComponent({component: 'refreshList'})
    }

    handleSubmit(e) {
        e.preventDefault();
        _patch(this.props.db, this.props.item, this.state.formEdit).then(async res => {
            (res.result === 'success')
                ? this.handleUploadPut()
                : this.props.notificationComponent({type: "error", message: res.data.messages})
        })
    }

    handleChange(e) {
        const formEdit = this.state.formEdit;
        formEdit[e.target.name] = e.target.value
        this.setState({
            formEdit: formEdit
        })
    }

    handleUploadImages(files) {
        this.setState({selectedFiles: files})
    }

    render() {

        return (
            <Fragment>
                {(this.state.formEdit) &&
                <div className="row">
                    <div className="col-lg-12">
                        <div className="card">
                            <div className="card-body">
                                <div className="card-body">
                                    {Object.values(this.state.errorMessage).map((error, i) => {
                                        return (
                                            <UncontrolledAlert
                                                color="danger"
                                                className="alert-dismissible fade show"
                                                role="alert"
                                                key={i}>
                                                <i className="mdi mdi-block-helper me-2"> </i>
                                                {error}
                                            </UncontrolledAlert>
                                        )
                                    })}
                                    {this.state.successMessage &&
                                    <UncontrolledAlert
                                        color="success"
                                        className="alert-dismissible fade show"
                                        role="alert">
                                        <i className="mdi mdi-check-all me-2"> </i> {this.state.successMessage}
                                    </UncontrolledAlert>
                                    }
                                    <h4 className="card-title">Edit</h4>
                                    <p className="card-title-desc">&nbsp;</p>
                                    <Form onSubmit={this.handleSubmit}>
                                        {(this.state.fields) ? this.state.fields.map((field, i) => {
                                            return (
                                                <DataTableForm {...this.props}
                                                               key={i}
                                                               fields={field}
                                                               formEdit={this.state.formEdit}
                                                               onChange={this.handleChange}
                                                               itemValue={this.state.formEdit[field.name]}
                                                               upload={this.handleUploadImages}/>
                                            )
                                        }) : null}
                                        <div className="row mb-3">
                                            <div className="col-sm-2 col-4 col-form-label">&nbsp;</div>
                                            <div className="col-sm-10 col-8">
                                                <Button outline
                                                        color="primary"
                                                        className="me-2">
                                                    <FontAwesomeIcon icon={faCloudUploadAlt}/> Submit
                                                </Button>

                                                <Button
                                                    onClick={() => this.props.hideComponent({component: this.props.return})}
                                                    outline
                                                    color={"secondary"}>
                                                    <FontAwesomeIcon icon={faWindowClose}/> Cancel
                                                </Button>
                                            </div>
                                        </div>
                                    </Form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                }
            </Fragment>
        )
    }
}

export default Edit;